import { useQuery } from '@tanstack/react-query';
import type { ApplicationsContract } from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import {
  tenantAwareApiWrapper,
  withOrchestratorClient,
} from '../../clients/tester-client/portal/portal-http';

export const DETECTED_LOGIN_BEHAVIOR_QUERY_KEY = 'detected-login-behavior';

const getDetectedLoginBehavior = (applicationId: string) =>
  tenantAwareApiWrapper<
    typeof ApplicationsContract.getLoginBehaviorObservations
  >({
    endpointFn: (headers) =>
      applicationsClient.getLoginBehaviorObservations({
        params: { id: applicationId },
        ...withOrchestratorClient(headers),
      }),
  });

export const useDetectedLoginBehavior = ({
  applicationId,
  enabled = true,
}: {
  applicationId: string;
  enabled?: boolean;
}) => {
  const { data } = useQuery({
    queryKey: [DETECTED_LOGIN_BEHAVIOR_QUERY_KEY, applicationId],
    queryFn: () => getDetectedLoginBehavior(applicationId),
    enabled: enabled && applicationId.length > 0,
  });

  return { detected: data };
};
